import { useCallback, useState } from 'react';

import { Plus } from 'lucide-react';
import { Button, DefaultPopover, DefaultTooltip, Input } from 'twyne-new.ui';

import { useAppAlert } from '@/components/AppAlert';
import { useGrid } from '@/components/Grid/context';

import { useBucketStore } from '../../../store';
import actionsConfig from '../actionsConfig';

export default function creditAction(info) {
  return <CreditAction info={info} />
}

function CreditAction({ info }) {
  const { item: { credit: action } } = actionsConfig
  const { id, subidKey: subid, status } = info.row.original
  const disabled = status === 'disabled'
  const { credit } = useBucketStore()
  const { handleRefresh } = useGrid()
  const { handleSuccess, handleError } = useAppAlert()
  const [open, setOpen] = useState(false)
  const [value, setValue] = useState('')

  const handleSubmit = useCallback(async () => {
    const parsed = Number(value)
    if (!parsed) return

    try {
      const ok = await credit({ id, subid, credit: parsed })
      if (!ok) throw new Error()
      await handleRefresh()
      handleSuccess('Success', 'Bucket updated.')
      setValue('')
      setOpen(false)
    } catch {
      handleError('Error', 'The bucket was not updated.')
    }
  }, [credit, id, subid, value, handleRefresh, handleSuccess, handleError])

  if (disabled) {
    return <div className={`opacity-40 ${action.class}`}>
      <Plus size={16} />
    </div>
  }

  return <>
    <DefaultPopover
      title={action.title}
      trigger={<DefaultTooltip content={action.tip} triggerProps={{ asChild: true }}>
        <Plus size={16} />
      </DefaultTooltip>}
      wrapperProps={{ open, onOpenChange: setOpen }}
    >
      <div className='flex flex-col gap-2'>
        <span>{action.content}</span>
        <Input
          type='number'
          value={value}
          onChange={event => setValue(event.target.value)}
          placeholder='Value'
        />
        <Button block color='accent' onClick={handleSubmit} disabled={!Number(value)}>
          {Number(value) < 0 ? 'Subtract' : 'Add'}
        </Button>
      </div>
    </DefaultPopover>
  </>
}
